/* src/app/features/tarefas/remuneracao/tarefas-remuneracao.component.scss */
h5 {
  margin-bottom: 40px;
}
.submit.col-auto {
  margin-top: 20px;
}
.d-flex.title {
  font-weight: bold;
}
::ng-deep .card .card-header > button {
  width: 100%;
}
/*# sourceMappingURL=tarefas-remuneracao.component.css.map */
